export default __webpack_public_path__ + "static/media/eo2-logo.852574dc.png";